import React from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

export default function SimpleTable({ data = [], darkMode = false, title }) {
  if (!data || data.length === 0)
    return <Typography align="center">No data available</Typography>;

  const keys = Object.keys(data[0]);

  const palette = darkMode
    ? {
        bg: "#0f172a",
        text: "#f1f5f9",
        headerBg: "#1e293b",
        headerText: "#38bdf8",
        rowAlt: "#1c2535",
        row: "#111827",
        hover: "#334155",
        scrollbarBg: "#1e293b",
        scrollbarThumb: "#3b82f6",
        shadow: "0 6px 18px rgba(0,0,0,0.5)",
        borderColor: "#334155",
      }
    : {
        bg: "#ffffff",
        text: "#1f2937",
        headerBg: "#e0f2fe",
        headerText: "#0c4a6e",
        rowAlt: "#f9fafb",
        row: "#ffffff",
        hover: "#bae6fd",
        scrollbarBg: "#cbd5e1",
        scrollbarThumb: "#60a5fa",
        shadow: "0 6px 18px rgba(0,0,0,0.08)",
        borderColor: "#e2e8f0",
      };

  return (
    <Paper
      sx={{
        borderRadius: 3,
        bgcolor: palette.bg,
        color: palette.text,
        boxShadow: palette.shadow,
        transition: "all 0.3s ease",
      }}
    >
      <TableContainer
        sx={{
          maxHeight: 450,
          borderRadius: 2,
          overflowY: "auto",
          scrollbarWidth: "thin",
          scrollbarColor: darkMode ? "#64748b #1e293b" : "#cbd5e1 #f0f4f8",
          "&::-webkit-scrollbar": { width: 2, height: 1 },
          "&::-webkit-scrollbar-track": { background: palette.scrollbarBg, borderRadius: 4 },
          "&::-webkit-scrollbar-thumb": { backgroundColor: palette.scrollbarThumb, borderRadius: 4 },
        }}
      >
        <Table stickyHeader sx={{ minWidth: 650, borderCollapse: "separate" }}>
          <TableHead>
            <TableRow>
              {keys.map((key) => (
                <TableCell
                  key={key}
                  sx={{
                    bgcolor: palette.headerBg,
                    color: palette.headerText,
                    fontWeight: 600,
                    textTransform: "capitalize",
                    borderBottom: `2px solid ${palette.borderColor}`,
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  }}
                >
                  {key.replace(/_/g, " ")}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {data.map((row, rowIndex) => (
              <TableRow
                key={rowIndex}
                sx={{
                  bgcolor: rowIndex % 2 === 0 ? palette.row : palette.rowAlt,
                  transition: "background 0.3s",
                  "&:hover": { bgcolor: palette.hover },
                }}
              >
                {keys.map((key) => (
                  <TableCell
                    key={key}
                    sx={{
                      py: 1.5,
                      borderBottom: `1px solid ${palette.borderColor}`,
                    }}
                  >
                    {typeof row[key] === "boolean" ? row[key].toString() : row[key]}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
